import {app} from '../app'

const mounted = (el, binding) => {
  el.addEventListener('ajax:success', () => {
    el.outerHTML = binding.value
  })
  el.addEventListener('ajax:error', (e) => {
    app.notify(e.detail[0], {type: 'error'})
  })
}

export default {
  mounted
}
